import { action, observable } from 'mobx';
import { useStaticRendering } from 'mobx-react';

import ApiCore from '../ApiCore';

const isServer = !process.browser;
useStaticRendering(isServer);


class ProductStore {
  @observable products = [];

  @observable product = {};

  @observable selectedFilters = {
    251: true,
    237: true,
    252: true,
  };

  /**
   * Get product list filtered by various parameters
   * @param {integer} page
   * @param {integer} limit
   * @param {string} category
   */
  @action index(page = 1, per_page = 50, category = '', status = 'publish') {
    return ApiCore.get(
      '/wc/v3/products',
      {
        page,
        per_page,
        category,
        status,
      },
      { page },
    ).then((response) => {
      this.products = {
        data: response.data,
        pagination: response.pagination,
      };
    // eslint-disable-next-line no-console
    }).catch(error => console.error(error)); // TODO fix productlist error handling
  }

  @action async emptyProducts() {
    this.products = [];
  }

  /**
   * Get a specific product by slug
   * @param {string} slug
   */
  @action show = slug => ApiCore.get('/wc/v3/products', { slug }).then((response) => {
    [this.product] = response.data;
  });

  @action setSelectedFilters = (category) => {
    if (typeof category === 'string' && category !== ['']) {
      // toggles the given checkbox
      this.selectedFilters[category] = !this.selectedFilters[category];
    } else {
      // resets every value if it gets and empty string
      this.selectedFilters[251] = true;
      this.selectedFilters[237] = true;
      this.selectedFilters[252] = true;
    }
  };

  @action clearProducts = () => {
    this.products = [];
  };
}

let productStore = null;

export default function initializeProductStore(initialData) {
  if (isServer) {
    return new ProductStore(isServer, initialData);
  }

  if (productStore === null) {
    productStore = new ProductStore(isServer, initialData);
  }

  return productStore;
}
